<template>
    <module-card ref="moduleCard">
        <div class="slot" v-for="(slot, index) in slots" :key="index" ref="slots">
            <p class="text-h6">{{ slot.text }}</p>
            <div class="slot__window">
                <div class="slot__wrap">
                    <div class="slot__item" v-for="(opt, index) in slot.choices" :key="index">{{ opt }}</div>
                    <div class="slot__item slot__item--copy">{{ slot.choices[0] }}</div>
                </div>
            </div>
        </div>

        <div>
            <div v-for="(choice, key) in answerChoices.choices" :key="key" :class="[isSelected(key) ? 'primary white--text' : 'grey lighten-3']" class="pa-3 mb-1" @click.stop="select(key)" v-ripple>
                <span :class="{ 'incorrect-selected': isIncorrectAlreadySelected(key) }">{{ choice.choice }}</span>
            </div>
        </div>

        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn large color="primary" @click="backClick()">Back</v-btn>
            <v-btn large color="primary" @click="checkAnswer()" :disabled="nextDisabled()">{{ nextLabel }}</v-btn>
            <v-spacer></v-spacer>
        </template>

        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { keyBy, shuffle, includes } from 'lodash';

    export default {
        data() {
            return {
                selectedAnswer: null,
                nextLabel: 'Next',
                incorrectSelected: [],
                incorrectMessages: ['Are you sure? Try again!', 'Not quite!', 'Close!'],
                answers: keyBy(
                    [
                        {
                            id: 1,
                            choices: [
                                {
                                    id: 1,
                                    choice: `I think ‘this sounds exciting’ and dive right in without any concerns!`,
                                    correct: false
                                },
                                {
                                    id: 2,
                                    choice: `I decide to do something lower risk, like masturbate in front of each other.`,
                                    correct: true
                                },
                                {
                                    id: 3,
                                    choice: `I take a deep breath to gather my thoughts, and decide to end the night instead of going any further.`,
                                    correct: true
                                }
                            ]
                        },
                        {
                            id: 2,
                            choices: [
                                {
                                    id: 1,
                                    choice: `I suddenly realize what’s happening and start to panic. I push the guy while yelling: “Get the hell away from me!”`,
                                    correct: false
                                },
                                {
                                    id: 2,
                                    choice: `I suddenly realize what’s happening and start to panic. I choose one of my handful of ways to manage strong feelings to get safely out of the situation.`,
                                    correct: true
                                },
                                {
                                    id: 3,
                                    choice: `I suddenly realize what’s happening and start to panic. I freeze and let him do whatever he wants to me.`,
                                    correct: false
                                }
                            ]
                        },
                        {
                            id: 3,
                            choices: [
                                {
                                    id: 1,
                                    choice: `I forget the steps to using a condom, so I just decide to take the risk and not use one.`,
                                    correct: false
                                },
                                {
                                    id: 2,
                                    choice: `I forget the steps to using a condom, so I direct him to another type of sex that’s less risky for HIV (e.g., oral sex, rimming)`,
                                    correct: true
                                },
                                {
                                    id: 3,
                                    choice: `I forget the steps to using a condom, so I decide to have sex without one if he says he’s clean and his butt and penis look and smell clean.`,
                                    correct: false
                                }
                            ]
                        }
                    ],
                    'id'
                )
            };
        },
        props: {
            id: {
                type: Number,
                required: false,
                default: 1
            }
        },
        computed: {
            slots() {
                let allSlots = this.$store.get(`content@getAClueSlots`);
                let choices = this.$store.get(`getAClueChoices@${this.id}.choices`);

                let s = [];

                for (let index = 0; index < allSlots.length; index++) {
                    const element = allSlots[index];

                    let o = {};
                    o.text = element.text;
                    o.choices = [];
                    o.choices.push(element.choices[choices[index]]);

                    s.push(o);
                }

                return s;
            },
            answerChoices() {
                return this.answers[this.id];
            }
        },
        methods: {
            backClick() {
                this.$refs.moduleCard.backClick();
            },
            select(key) {
                this.selectedAnswer = key;
            },
            isSelected(key) {
                if (parseInt(key) === parseInt(this.selectedAnswer)) return true;
                else return false;
            },
            nextDisabled() {
                if (this.selectedAnswer === null) return true;
                else return false;
            },
            checkAnswer() {
                if (!this.answerChoices.choices[this.selectedAnswer].correct) {
                    this.$refs.modalFeedback.show(false, shuffle(this.incorrectMessages)[0], () => {
                        if (!includes(this.incorrectSelected, this.selectedAnswer)) {
                            this.incorrectSelected.push(this.selectedAnswer);
                            this.selectedAnswer = null;
                        }
                    });
                } else {
                    this.$refs.modalFeedback.show(true, `That's smart!`, () => {
                        this.$refs.moduleCard.nextClick();
                    });
                }
            },
            isIncorrectAlreadySelected(key) {
                return this.incorrectSelected.includes(key);
            }
        }
    };
</script>

<style scoped>
    .slot__window {
        width: 100%;
        height: 50px;
        overflow: hidden;
    }

    .slot__item {
        height: 50px;
        width: 100%;

        text-align: left;
        vertical-align: middle;
    }

    .incorrect-selected {
        text-decoration: line-through;
        text-decoration-color: red;
    }
</style>
